import {UserType} from "../../../Types/UserType";
import {useContext} from "react";
import {UserContext} from "../../../Contexts/UserContext";
import {ChannelContext} from "../../../Contexts/ChannelContext";
import {ChannelType} from "../../../Types/ChannelType";

function useIsOnlySpecialOffers(): boolean {
    const userContext = useContext(UserContext);
    const channelContext = useContext(ChannelContext);

    if (!userContext?.user){
        return false;
    }

    const channelId: number|undefined = channelContext?.id;
    let isOnly: boolean = false;


    userContext?.user && userContext?.user.specialOfferSalesDepartments.map((saleDepartment: ChannelType) => {
        if (saleDepartment.id === channelId){
            isOnly = true;
        }
    });

    return isOnly;
}

export {useIsOnlySpecialOffers};